import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


// ASCII art
console.log(`
  %c
▄▖    ▜     ▄▖  
▙▌▀▌▛▌▐ ▛▌  ▌▌  
▌ █▌▙▌▐▖▙▌  ▛▌▗ 
                                                          
  `, 'color: #6366f1; font-family: monospace;',);

console.log(
  '%cPersonal Portfolio',
  'color: #94a3b8; font-style: italic; font-size: 12px;'
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
